<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pi_inoutno"
      placeholder="输入单据编号进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/production/make_cut_return/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.pi_inoutno}}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.createTime}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.creatorName}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.pi_status=='未审核'}"
          >{{item.pi_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
      <!-- <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('ms_total')}}</em> -->
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/prodinout/list",
      filters: [
        {
          type: "date",
          name: "pi_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "pi_class = 'MAKECUTRETURN'"
            },
            {
              value: 1,
              label: "未审核",
              mode: 'MAIN',
              condition: "pi_status = '未审核' and pi_class = 'MAKECUTRETURN'"
            },
            {
              value: 2,
              label: "已审核",
              mode: 'MAIN',
              condition: "pi_status = '已审核' and pi_class = 'MAKECUTRETURN'"
            }
          ]
        }
      ]
    };
  }
};
</script>